import { WorkerDbModel } from '@models/worker-db.model';

// Multi-store (addon): a worker can serve several stores via `worker.stores[]`.
// When the addon is off the array is empty/absent, so every helper falls back to
// the single `worker.store_id` / `worker.store` — keeping single-store behaviour
// byte-for-byte identical to today.
function servedStoreIds(worker: WorkerDbModel): number[] {
  return worker?.stores?.length ? worker.stores.map(s => s.id) : [worker?.store_id];
}

export function workerServesStore(worker: WorkerDbModel, storeId: number): boolean {
  if (storeId == null) {
    return false;
  }
  return servedStoreIds(worker).includes(storeId);
}

export function workerServesStoreUuid(worker: WorkerDbModel, uuid: string): boolean {
  if (!uuid) {
    return false;
  }
  return worker?.stores?.length ? worker.stores.some(s => s.uuid === uuid) : worker?.store?.uuid === uuid;
}
